import { render, staticRenderFns } from "./ProductCategoryFilterOpen.vue?vue&type=template&id=6158a0c8&scoped=true"
import script from "./ProductCategoryFilterOpen.vue?vue&type=script&lang=js"
export * from "./ProductCategoryFilterOpen.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryFilterOpen.vue?vue&type=style&index=0&id=6158a0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6158a0c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuCloseIcon: require('/vercel/path0/components/icons/MenuCloseIcon.vue').default,CornerButton: require('/vercel/path0/components/shared/CornerButton.vue').default})
